import { render, staticRenderFns } from "./OnboardingStaff.vue?vue&type=template&id=88cb5334&"
import script from "./OnboardingStaff.vue?vue&type=script&lang=js&"
export * from "./OnboardingStaff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports